import { IconProps } from "./types";
import React from "react";

export const CommentsIcon = ({
  className,
  fill = "currentColor",
  width = 24,
  height = 24,
  style = {},
  count = 0,
}: IconProps & {
  count?: number;
}): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 24 24"
    className={className}
    style={style}
  >
    {/* Comment bubble */}
    <path
      d="M20 2H4a2 2 0 0 0-2 2v14l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"
      fill={fill}
    />

    {/* Notification badge */}
    {count > 0 && (
      <React.Fragment>
        <circle cx="18" cy="6" r="6" fill="red" />
        <text
          x="18"
          y="7"
          textAnchor="middle"
          fontSize="7"
          fontWeight="bold"
          fill="white"
          dy=".3em"
        >
          {count}
        </text>
      </React.Fragment>
    )}
  </svg>
);
